export default {
  accessToken: null,
  environment: import.meta.env.VITE_APP_ENV,
  version: import.meta.env.VITE_VERSION
}
